<div class="config-wrapper px-0 px-sm-2 py-2 h-100-margin overflow-auto">
    <mat-tab-group class="config-tabs" animationDuration="0ms" [selectedIndex]="selectedTabIndex"
        (selectedTabChange)="onTabsChange($event)">
        <mat-tab label="Operación y Rastreo" *ngIf="tabsAndSectionsToShow['OperationAndTracking']">
            <div class="config-tab-content">
                <div class="config-tab-toolbar">
                    <button mat-icon-button type="button" class="config-refresh-btn"
                        (click)="refreshTab('OperationAndTracking')"
                        [disabled]="tabState['OperationAndTracking'].loading" matTooltip="Refrescar">
                        <i class="fas fa-sync-alt" [class.fa-spin]="tabState['OperationAndTracking'].loading"></i>
                    </button>
                </div>

                <div *ngIf="tabState['OperationAndTracking'].loading" class="config-skeleton">
                    <ngx-skeleton-loader count="5" appearance="line"
                        [theme]="{ height: '48px', 'margin-bottom': '14px' }"></ngx-skeleton-loader>
                </div>

                <div [hidden]="tabState['OperationAndTracking'].loading">
                    <!-- Alertas por desvío de ruta -->
                    <div class="config-section config-block"
                        [ngClass]="{'config-row--active': formRouteDetour?.get('active')?.value}"
                        *ngIf="tabsAndSectionsToShow['OperationAndTracking']['routeDetour']">
                        <form class="config-inline-row" [formGroup]="formRouteDetour"
                            (ngSubmit)="onSubmitRouteDetour()">
                            <mat-checkbox (change)="onChangeActiveRouteDetour($event)"
                                [formControl]="formRouteDetour?.get('active')">
                                <p class="text-bold mb-0">Alertas por desvío de ruta</p>
                                <small>Permite habilitar las alertas por desvío de ruta y a cuántos
                                    metros activarlas.</small>
                            </mat-checkbox>
                            <mat-form-field appearance="outline" class="config-input">
                                <mat-label>Metros para activar alerta<span class="asterisk">*</span></mat-label>
                                <input matInput type="text" onlyNumbersInt formControlName="metters" placeholder="500">
                            </mat-form-field>
                            <button mat-raised-button color="primary" class="bg-color-primary"
                                type="submit">Guardar</button>
                        </form>
                    </div>

                    <!-- Rastreo satelital -->
                    <form class="config-section config-row" [formGroup]="formSatelliteTracking"
                        [ngClass]="{'config-row--active': formSatelliteTracking?.get('active')?.value}"
                        *ngIf="tabsAndSectionsToShow['OperationAndTracking']['satelliteTracking']">
                        <mat-checkbox (change)="onSubmitSatelliteTracking()"
                            [formControl]="formSatelliteTracking?.get('active')" class="w-100">
                            <p class="text-bold mb-0">Rastreo satelital</p>
                            <small>Si está activo, al iniciar el servicio se registra automáticamente el rastreo
                                satelital
                                (Monitor) del vehículo, sin ingresar las fechas manualmente.</small>
                        </mat-checkbox>
                    </form>

                    <!-- Publicación por defecto como pública -->
                    <form class="config-section config-row" [formGroup]="formPublicationByDefault"
                        [ngClass]="{'config-row--active': formPublicationByDefault?.get('active')?.value}"
                        *ngIf="tabsAndSectionsToShow['OperationAndTracking']['publicationByDefault']">
                        <mat-checkbox (change)="onSubmitPublicationByDefault()"
                            [formControl]="formPublicationByDefault?.get('active')" class="w-100">
                            <p class="text-bold mb-0">Publicación por defecto como pública</p>
                            <small>Al marcar, la publicación de servicios quedará por defecto como pública.</small>
                        </mat-checkbox>
                    </form>

                    <!-- Usar las mismas evidencias del descargue en las guías -->
                    <form class="config-section config-row" [formGroup]="formUseEvidenceToGuides"
                        [ngClass]="{'config-row--active': formUseEvidenceToGuides?.get('active')?.value}"
                        *ngIf="tabsAndSectionsToShow['OperationAndTracking']['useEvidenceToGuides']">
                        <mat-checkbox (change)="onSubmitUseEvidenceToGuides()"
                            [formControl]="formUseEvidenceToGuides?.get('active')" class="w-100 text-bold">
                            <p class="text-bold mb-0">Usar las mismas evidencias del descargue en las guías</p>
                            <small>Usa las evidencias subidas en el descargue como evidencias de llegada en las guías
                                asociadas.</small>
                        </mat-checkbox>
                    </form>

                    <!-- Trazabilidad con múltiples GPS -->
                    <form class="config-section config-row" [formGroup]="formIntegration"
                        [ngClass]="{'config-row--active': formIntegration?.get('monitor')?.value}"
                        *ngIf="tabsAndSectionsToShow['OperationAndTracking']['integrationMonitor']">
                        <mat-checkbox (change)="onChangeMonitor($event.checked)"
                            [formControl]="formIntegration?.get('monitor')" class="w-100 text-bold">
                            <p class="text-bold mb-0">Trazabilidad con múltiples GPS</p>
                            <small>Realiza la trazabilidad a través del sistema de integración de múltiples GPS. Este
                                servicio tiene costo adicional.</small>
                        </mat-checkbox>
                    </form>
                    <!-- Validación previa -->
                    <form class="config-section config-row" [formGroup]="formRequiresPreValidation"
                        [ngClass]="{'config-row--active': formRequiresPreValidation?.get('active')?.value}"
                        *ngIf="tabsAndSectionsToShow['OperationAndTracking']['requiresPreValidation']">
                        <mat-checkbox (change)="onSubmitRequiresPreValidation($event.checked)"
                            [formControl]="formRequiresPreValidation?.get('active')" class="w-100 text-bold">
                            <p class="text-bold mb-0">Validación previa</p>
                            <small>Los servicios requieren validación previa para ser facturados.</small>
                        </mat-checkbox>
                    </form>
                    <!-- Prefacturas requieren validación -->
                    <form class="config-section config-row" [formGroup]="formPrebillRequiresValidation"
                        [ngClass]="{'config-row--active': formPrebillRequiresValidation?.get('active')?.value}"
                        *ngIf="tabsAndSectionsToShow['OperationAndTracking']['prebillRequiresValidation']">
                        <mat-checkbox (change)="onSubmitPrebillRequiresValidation($event.checked)"
                            [formControl]="formPrebillRequiresValidation?.get('active')" class="w-100 text-bold">
                            <p class="text-bold mb-0">Prefacturas validables</p>
                            <small>Las prefacturas requieren validación para ser facturadas.</small>
                        </mat-checkbox>
                    </form>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Seguridad" *ngIf="tabsAndSectionsToShow['Security']">
            <div class="config-tab-content">
                <div class="config-tab-toolbar">
                    <button mat-icon-button type="button" class="config-refresh-btn" (click)="refreshTab('Security')"
                        [disabled]="tabState['Security'].loading" matTooltip="Refrescar">
                        <i class="fas fa-sync-alt" [class.fa-spin]="tabState['Security'].loading"></i>
                    </button>
                </div>

                <div *ngIf="tabState['Security'].loading" class="config-skeleton">
                    <ngx-skeleton-loader count="5" appearance="line"
                        [theme]="{ height: '48px', 'margin-bottom': '14px' }"></ngx-skeleton-loader>
                </div>

                <div [hidden]="tabState['Security'].loading">
                    <!-- Políticas de seguridad -->
                    <div class="config-section config-block"
                        *ngIf="tabsAndSectionsToShow['Security']['securityPolicies']">
                        <form [formGroup]="formSecurityPolicies" (ngSubmit)="onSubmitSecurityPolicies()">
                            <div class="config-block__head">
                                <span class="config-title">Políticas de seguridad</span>
                                <small>Determina los documentos que serán solicitados y los estudios obligatorios para
                                    los
                                    usuarios. Puede seguir realizándolos de forma opcional aunque no los marque.</small>
                            </div>
                            <div class="config-grid">
                                <div *ngFor="let entity of entitiesFields" class="config-grid__item"
                                    [ngClass]="{'d-none':!hasValidationRules(entity)}">
                                    <span class="config-subtitle">{{entitiesDict[entity]}}</span>
                                    <div *ngIf="formSecurityPolicies.get(entity)?.get('state')"
                                        class="d-flex flex-column">
                                        <div *ngFor="let stateField of stateFields"
                                            [ngClass]="{'d-none':!formSecurityPolicies.get(entity)?.get('state')?.get(stateField)}">
                                            <mat-checkbox
                                                *ngIf="formSecurityPolicies.get(entity)?.get('state')?.get(stateField)"
                                                [formControl]="formSecurityPolicies.get(entity).get('state').get(stateField)">
                                                {{stateDict[stateField]}}
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                    <div *ngIf="formSecurityPolicies.get(entity)?.get('security')"
                                        class="d-flex flex-column">
                                        <div *ngFor="let securityField of securityFields"
                                            [ngClass]="{'d-none':!formSecurityPolicies.get(entity)?.get('security')?.get(securityField)}">
                                            <span
                                                *ngIf="securityField === 'truora' && formSecurityPolicies.get(entity)?.get('security')?.get(securityField)"
                                                [matTooltip]="!isSecurityStudyRequired ? serviceMessages.SECURITY_STUDY_DISABLED_TOOLTIP : ''"
                                                matTooltipPosition="above" matTooltipClass="tooltip__alert">
                                                <mat-checkbox
                                                    [formControl]="formSecurityPolicies.get(entity).get('security').get(securityField)">
                                                    {{securityDict[securityField]}}
                                                </mat-checkbox>
                                            </span>
                                            <mat-checkbox
                                                *ngIf="securityField !== 'truora' && formSecurityPolicies.get(entity)?.get('security')?.get(securityField)"
                                                [formControl]="formSecurityPolicies.get(entity).get('security').get(securityField)">
                                                {{securityDict[securityField]}}
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="button-container mt-2 d-flex justify-content-end">
                                <button mat-raised-button color="primary" class="bg-color-primary"
                                    type="submit">Guardar</button>
                            </div>
                        </form>
                    </div>
                    <!-- Lista de empresas restringidas de transporte -->
                    <div class="config-section config-block"
                        *ngIf="tabsAndSectionsToShow['Security']['transportCompanyBlackList']">
                        <form (ngSubmit)="onSubmitTransportCompanyBlackList()">
                            <div class="config-block__head">
                                <span class="config-title">Lista de empresas restringidas de transporte</span>
                                <small>Permite añadir empresas de transporte a una lista restringida para bloquear la
                                    asignación de vehículos y desactivar a los usuarios que hayan tenido manifiestos
                                    con estas empresas.</small>
                            </div>
                            <mat-form-field appearance="outline" class="config-input--wide blacklist-search">
                                <mat-label>Agregar empresa de transporte</mat-label>
                                <input matInput [formControl]="transportCompanySearchControl"
                                    [matAutocomplete]="transportCompanyBlackListAuto"
                                    placeholder="Buscar por nombre o NIT">
                                <mat-autocomplete #transportCompanyBlackListAuto="matAutocomplete"
                                    [displayWith]="displayTransportCompanyName"
                                    (optionSelected)="onSelectTransportCompanyBlackList($event)">
                                    <mat-option *ngFor="let item of filteredTransportCompanies" [value]="item">
                                        <span>{{ item.name }}({{ item.id }})</span>
                                    </mat-option>
                                    <mat-option *ngIf="!filteredTransportCompanies.length" disabled>
                                        No hay empresas disponibles
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>

                            <div class="blacklist-cards" *ngIf="transportCompanyBlackList.length">
                                <div class="blacklist-card"
                                    *ngFor="let item of transportCompanyBlackList; trackBy: trackByCatalogItemId">
                                    <button mat-icon-button type="button" class="blacklist-card__remove"
                                        (click)="removeTransportCompanyFromBlackList(item)"
                                        matTooltip="Quitar de la lista restringida">
                                        <i class="fas fa-times"></i>
                                    </button>
                                    <p class="blacklist-card__name">{{ item.name }}</p>
                                    <small class="blacklist-card__nit">NIT {{ item.id }}</small>
                                </div>
                            </div>
                            <p class="blacklist-empty" *ngIf="!transportCompanyBlackList.length">
                                No hay empresas en la lista restringida.
                            </p>

                            <div class="button-container mt-2 d-flex justify-content-end">
                                <button mat-raised-button color="primary" class="bg-color-primary"
                                    type="submit">Guardar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Vehículos y Conductores" *ngIf="tabsAndSectionsToShow['VehiclesAndDrivers']">
            <div class="config-tab-content config-tab-content--cards">
                <div class="config-tab-toolbar">
                    <button mat-icon-button type="button" class="config-refresh-btn"
                        (click)="refreshTab('VehiclesAndDrivers')" [disabled]="tabState['VehiclesAndDrivers'].loading"
                        matTooltip="Refrescar">
                        <i class="fas fa-sync-alt" [class.fa-spin]="tabState['VehiclesAndDrivers'].loading"></i>
                    </button>
                </div>

                <div *ngIf="tabState['VehiclesAndDrivers'].loading" class="config-skeleton">
                    <ngx-skeleton-loader count="5" appearance="line"
                        [theme]="{ height: '48px', 'margin-bottom': '14px' }"></ngx-skeleton-loader>
                </div>

                <div [hidden]="tabState['VehiclesAndDrivers'].loading">
                    <!-- Documentos adicionales del vehículo -->
                    <div class="config-card config-block"
                        *ngIf="tabsAndSectionsToShow['VehiclesAndDrivers']['vehicleDocuments']">
                        <form *ngIf="formVehicleDocuments">
                            <div class="config-block__head">
                                <span class="config-title">Documentos adicionales del vehículo</span>
                                <small>Elige qué documentos adicionales se mostrarán para los vehículos y cuáles serán
                                    requeridos.</small>
                            </div>
                            <div class="docs-container">
                                <div *ngFor="let document of formVehicleDocuments?.controls" class="document-card"
                                    [ngClass]="{'disabled-check':document?.get('mandatory')?.disabled, 'document-card--active':document?.get('active')?.value}">
                                    <p class="w-100 text-bold mb-0">
                                        <mat-checkbox (change)="onChangeActiveDocument(document)"
                                            [formControl]="document?.get('active')">
                                            {{document?.get('name').value}}
                                        </mat-checkbox>
                                    </p>
                                    <mat-button-toggle-group name="fees" [formControl]="document?.get('mandatory')">
                                        <mat-button-toggle [value]="true"><b>Obligatorio</b></mat-button-toggle>
                                        <mat-button-toggle [value]="false">Opcional</mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>
                            </div>

                            <div class="config-block__actions mt-2">
                                <button mat-raised-button color="primary" class="bg-color-primary" type="button"
                                    (click)="onSubmitVehicleDocuments()">Guardar</button>
                            </div>
                        </form>
                    </div>

                    <!-- Descuentos de fidelidad de la flota -->
                    <div class="config-card config-block"
                        *ngIf="tabsAndSectionsToShow['VehiclesAndDrivers']['fleetLoyalty']">
                        <form>
                            <div class="config-block__head">
                                <span class="config-title">Descuentos de fidelidad de la flota</span>
                                <small>Personaliza los descuentos de fidelidad de los tipos de flota.</small>
                            </div>
                            <mat-form-field appearance="outline" class="config-input config-input--wide">
                                <mat-label>Agregar categoría de flota</mat-label>
                                <mat-select [formControl]="fleetLoyaltyControl" [compareWith]="compareFleetLoyalty"
                                    (selectionChange)="onSelectFleetLoyalty($event.value)" multiple>
                                    <mat-option *ngFor="let fleetType of listFleetTypes" [value]="fleetType"
                                        [disabled]="disableFleetLoyalty(fleetType.description)">
                                        {{fleetType?.description}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="fleet-loyalty-item"
                                *ngFor="let fleetLoyalty of formFleetLoyalty?.controls; let i = index">
                                <span class="fleet-loyalty-item__head text-bold">
                                    {{fleetLoyalty?.get('category')?.value?.description}}
                                </span>
                                <div class="config-row" *ngIf="hasAppUsageDiscountEnabled"
                                    [ngClass]="{'config-row--active': fleetLoyalty?.get('appUsageDiscountApplied')?.value}">
                                    <mat-checkbox
                                        (change)="onChangeEnableFleetLoyalty($event,'appUsageDiscountApplied', i)"
                                        [formControl]="fleetLoyalty?.get('appUsageDiscountApplied')" class="text-bold">
                                        Descuento por uso de la app
                                    </mat-checkbox>
                                    <mat-form-field appearance="outline" class="config-input">
                                        <mat-label>Porcentaje de descuento<span class="asterisk">*</span></mat-label>
                                        <input matInput type="text" onlyNumbersDouble name="appUsageDiscountPercentage"
                                            [formControl]="fleetLoyalty?.get('appUsageDiscountPercentage')"
                                            placeholder="20">
                                    </mat-form-field>
                                </div>
                                <div class="config-row" *ngIf="hasFastPaymentEnabled"
                                    [ngClass]="{'config-row--active': fleetLoyalty?.get('fastPaymentDiscountApplied')?.value}">
                                    <mat-checkbox
                                        (change)="onChangeEnableFleetLoyalty($event,'fastPaymentDiscountApplied', i)"
                                        [formControl]="fleetLoyalty?.get('fastPaymentDiscountApplied')"
                                        class="text-bold">
                                        Descuento por pronto pago
                                    </mat-checkbox>
                                    <mat-form-field appearance="outline" class="config-input">
                                        <mat-label>Porcentaje de descuento<span class="asterisk">*</span></mat-label>
                                        <input matInput type="text" onlyNumbersDouble
                                            name="fastPaymentDiscountPercentage"
                                            [formControl]="fleetLoyalty?.get('fastPaymentDiscountPercentage')"
                                            placeholder="20">
                                    </mat-form-field>
                                </div>
                                <div class="fleet-loyalty-item__quantity" *ngIf="fleetLoyalty?.get('quantity')">
                                    <mat-form-field appearance="outline" class="config-input">
                                        <mat-label>Cantidad de viajes<span class="asterisk">*</span></mat-label>
                                        <input matInput type="text" onlyNumbersInt name="quantity"
                                            [formControl]="fleetLoyalty?.get('quantity')" placeholder="10">
                                    </mat-form-field>
                                </div>
                                <div class="fleet-loyalty-item__meta"
                                    *ngIf="fleetLoyalty?.get('createdBy.userName')?.value || fleetLoyalty?.get('updatedBy.userName')?.value">
                                    <span *ngIf="fleetLoyalty?.get('createdBy.userName')?.value">
                                        <b>Creado por:</b> {{fleetLoyalty?.get('createdBy.userName')?.value}}
                                        ({{fleetLoyalty?.get('createdBy')?.value?.userId}}) -
                                        {{fleetLoyalty?.get('createdBy')?.value?.date | dateFormat}}
                                    </span>
                                    <span *ngIf="fleetLoyalty?.get('updatedBy.userName')?.value">
                                        <b>Actualizado por:</b> {{fleetLoyalty?.get('updatedBy.userName')?.value}}
                                        ({{fleetLoyalty?.get('updatedBy')?.value?.userId}}) -
                                        {{fleetLoyalty?.get('updatedBy')?.value?.date | dateFormat}}
                                    </span>
                                </div>
                            </div>
                            <div class="config-block__actions" *ngIf="formFleetLoyalty?.controls?.length">
                                <button mat-raised-button color="primary" class="bg-color-primary" type="submit"
                                    (click)="onSubmitFleetLoyalty()">Guardar</button>
                            </div>
                        </form>
                    </div>

                    <!-- Configuración de SOAT y RTM -->
                    <div class="config-card config-block"
                        *ngIf="tabsAndSectionsToShow['VehiclesAndDrivers']['soatRtm']">
                        <form *ngIf="formSoatRtm" [formGroup]="formSoatRtm" (ngSubmit)="onSubmitSoatRtm()">
                            <div class="config-block__head">
                                <span class="config-title">Configuración de SOAT y RTM</span>
                                <small>Personaliza los tiempos (en días) para las validaciones de SOAT y RTM: período de
                                    advertencia y de bloqueo, y activa o desactiva las alertas y bloqueos.</small>
                            </div>
                            <div class="config-inline-row pt-2"
                                [ngClass]="{'config-row--active': formSoatRtm?.get('soatAlertsAndBlocksEnabled')?.value}">
                                <mat-checkbox (change)="onChangeEnable($event,'SOAT')"
                                    [formControl]="formSoatRtm?.get('soatAlertsAndBlocksEnabled')" class="text-bold">
                                    Alertar y bloquear SOAT
                                </mat-checkbox>
                                <div class="input-row">
                                    <mat-form-field appearance="outline" class="config-input">
                                        <mat-label>Advertencia (días)<span class="asterisk">*</span></mat-label>
                                        <input matInput type="text" onlyNumbersInt name="daysToAlertExpirationSOAT"
                                            formControlName="daysToAlertExpirationSOAT"
                                            [placeholder]="vehicleMessages.DAYS_TO_ALERT_EXPIRATION_DEFAULT">
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" class="config-input ml-0 ml-sm-2">
                                        <mat-label>Bloqueo (días)<span class="asterisk">*</span></mat-label>
                                        <input matInput type="text" onlyNumbersInt name="daysToBlockSOAT"
                                            formControlName="daysToBlockSOAT"
                                            [placeholder]="vehicleMessages.DAYS_TO_BLOCK_DEFAULT">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="config-inline-row pt-2"
                                [ngClass]="{'config-row--active': formSoatRtm?.get('rtmAlertsAndBlocksEnabled')?.value}">
                                <mat-checkbox (change)="onChangeEnable($event,'RTM')"
                                    [formControl]="formSoatRtm?.get('rtmAlertsAndBlocksEnabled')" class="text-bold">
                                    Alertar y bloquear RTM
                                </mat-checkbox>
                                <div class="input-row">
                                    <mat-form-field appearance="outline" class="config-input">
                                        <mat-label>Advertencia (días)<span class="asterisk">*</span></mat-label>
                                        <input matInput type="text" onlyNumbersInt name="daysToAlertExpirationRTM"
                                            formControlName="daysToAlertExpirationRTM"
                                            [placeholder]="vehicleMessages.DAYS_TO_ALERT_EXPIRATION_DEFAULT">
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" class="config-input ml-0 ml-sm-2">
                                        <mat-label>Bloqueo (días)<span class="asterisk">*</span></mat-label>
                                        <input matInput type="text" onlyNumbersInt name="daysToBlockRTM"
                                            formControlName="daysToBlockRTM"
                                            [placeholder]="vehicleMessages.DAYS_TO_BLOCK_DEFAULT">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="config-block__actions">
                                <button mat-raised-button color="primary" class="bg-color-primary"
                                    type="submit">Guardar</button>
                            </div>
                        </form>
                    </div>

                    <!-- Máximo de días de inactividad para bloquear vehículos -->
                    <form class="config-card config-row"
                        *ngIf="tabsAndSectionsToShow['VehiclesAndDrivers']['daysToDeactivateVehicle']"
                        [formGroup]="formVehicle" (ngSubmit)="onSubmitVehicle()">
                        <div>
                            <span class="config-title">Máximo de días de inactividad para bloquear vehículos<span
                                    class="asterisk">*</span></span>
                            <mat-form-field appearance="outline" class="config-input config-input--wide">
                                <input matInput type="text" onlyNumbersInt name="daysToDeactivateVehicle"
                                    formControlName="daysToDeactivateVehicle"
                                    [placeholder]="vehicleMessages.DAYS_TO_DEACTIVE_VEHICLES_DEFAULT">
                            </mat-form-field>
                        </div>
                        <button mat-raised-button color="primary" class="bg-color-primary"
                            type="submit">Guardar</button>
                    </form>

                    <!-- Inspecciones y opciones adicionales -->
                    <div class="config-card config-card--group">
                        <!-- Inspección preoperacional vehicular -->
                        <form class="config-row" [formGroup]="formVehicleInspection"
                            *ngIf="tabsAndSectionsToShow['VehiclesAndDrivers']['vehicleInspection']">
                            <div class="config-info flex-wrap">
                                <span class="config-title">Inspección preoperacional vehicular</span>
                                <small>Configura si la inspección preoperacional vehicular se realizará mediante
                                    formulario
                                    o
                                    subiendo un documento.</small>
                            </div>
                            <mat-radio-group formControlName="active" class="config-control"
                                (change)="onSubmitInspection('vehicleInspection')">
                                <mat-radio-button value="Documento" class="mr-2">Documento</mat-radio-button>
                                <mat-radio-button value="Formulario" class="mr-2">Formulario</mat-radio-button>
                                <mat-radio-button value="Ambos">Ambos</mat-radio-button>
                            </mat-radio-group>
                        </form>

                        <!-- Inspección de contenedor -->
                        <form class="config-row" [formGroup]="formContainerInspection"
                            *ngIf="tabsAndSectionsToShow['VehiclesAndDrivers']['containerInspection']">
                            <div class="config-info flex-wrap">
                                <span class="config-title">Inspección de contenedor</span>
                                <small>Configura si la inspección de contenedor se realizará mediante formulario o
                                    subiendo
                                    un
                                    documento.</small>
                            </div>
                            <mat-radio-group formControlName="active" class="config-control"
                                (change)="onSubmitInspection('containerInspection')">
                                <mat-radio-button value="Documento" class="mr-2">Documento</mat-radio-button>
                                <mat-radio-button value="Formulario" class="mr-2">Formulario</mat-radio-button>
                                <mat-radio-button value="Ambos">Ambos</mat-radio-button>
                            </mat-radio-group>
                        </form>

                        <!-- Realizar estudio de seguridad en hojas de vida -->
                        <form class="config-row" [formGroup]="formResume"
                            [ngClass]="{'config-row--active': formResume?.get('allowCreatingWithoutTruora')?.value}"
                            *ngIf="tabsAndSectionsToShow['VehiclesAndDrivers']['allowCreatingWithoutTruora']">
                            <mat-checkbox (change)="onSubmitResume()"
                                [formControl]="formResume?.get('allowCreatingWithoutTruora')" class="w-100 text-bold">
                                Realizar estudio de seguridad en hojas de vida
                            </mat-checkbox>
                        </form>

                        <!-- ¿Sus servicios son mayormente realizados con flota propia? -->
                        <form class="config-row" [formGroup]="formFees"
                            [ngClass]="{'config-row--active': formFees?.get('active')?.value}"
                            *ngIf="tabsAndSectionsToShow['VehiclesAndDrivers']['fees']">
                            <mat-checkbox (change)="onSubmitFees()" [formControl]="formFees?.get('active')"
                                class="w-100 text-bold">
                                ¿Sus servicios son mayormente realizados con flota propia?
                            </mat-checkbox>
                        </form>
                    </div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Facturación y Contabilidad" *ngIf="tabsAndSectionsToShow['BillingAndPayments']">
            <div class="config-tab-content config-tab-content--cards">
                <div class="config-tab-toolbar">
                    <button mat-icon-button type="button" class="config-refresh-btn"
                        (click)="refreshTab('BillingAndPayments')" [disabled]="tabState['BillingAndPayments'].loading"
                        matTooltip="Refrescar">
                        <i class="fas fa-sync-alt" [class.fa-spin]="tabState['BillingAndPayments'].loading"></i>
                    </button>
                </div>

                <div *ngIf="tabState['BillingAndPayments'].loading" class="config-skeleton">
                    <ngx-skeleton-loader count="5" appearance="line"
                        [theme]="{ height: '48px', 'margin-bottom': '14px' }"></ngx-skeleton-loader>
                </div>

                <div [hidden]="tabState['BillingAndPayments'].loading">
                    <!-- SaaS sin servicios de transporte: no hay empresas de transporte y la facturación Siigo sigue siendo de la SaaS. -->
                    <ng-container *ngIf="tabsAndSectionsToShow['BillingAndPayments']['typeBill']">
                        <ng-container *ngTemplateOutlet="siigoBillingSections"></ng-container>
                    </ng-container>

                    <!-- Centros de costo + Habilitar factura tipo 12 -->
                    <div class="config-card config-card--group"
                        *ngIf="tabsAndSectionsToShow['BillingAndPayments']['costCenterSiigo'] || tabsAndSectionsToShow['BillingAndPayments']['enableType12InvoiceSiigo']">
                        <div id="costCenterStep" class="config-row"
                            *ngIf="tabsAndSectionsToShow['BillingAndPayments']['costCenterSiigo']">
                            <div class="config-info flex-wrap">
                                <span class="config-title">Centros de costo</span>
                                <small>Para que las facturas se generen correctamente, es necesario configurar el centro
                                    de
                                    costo por cada empresa registrada.</small>
                            </div>
                            <u class="cursor-pointer text-bold color-secondary-dark config-action-link"
                                [routerLink]="['administration/companies/list']">
                                <i class="fas fa-sign-in-alt"></i>
                                Ir a la lista de empresas
                            </u>
                        </div>

                        <div id="enableType12InvoiceStep" class="config-row"
                            *ngIf="tabsAndSectionsToShow['BillingAndPayments']['enableType12InvoiceSiigo']">
                            <div class="config-info flex-wrap">
                                <span class="config-title">Habilitar factura tipo 12 en Siigo</span>
                                <small>Guía para habilitar la factura tipo 12 en la plataforma de Siigo.</small>
                            </div>
                            <u (click)="openModalCargoPDF('assets/pdfs/Configuracion-requerida-para-siigo.pdf')"
                                class="cursor-pointer text-bold color-secondary-dark config-action-link">
                                <i class="fas fa-eye"></i>
                                Ver guía explicativa
                            </u>
                        </div>
                    </div>

                    <!-- Contabilidad -->
                    <div class="config-card config-block"
                        *ngIf="tabsAndSectionsToShow['BillingAndPayments']['accountingSiigo']">
                        <div class="config-block__head">
                            <span class="config-title">Contabilidad</span>
                            <small>Configura los consecutivos. El siguiente comprobante generado tendrá el consecutivo
                                directamente superior al configurado.</small>
                        </div>
                        <div class="config-fields-grid">
                            <div class="field-with-action">
                                <mat-form-field appearance="outline">
                                    <mat-label>Consecutivo de comprobantes contables</mat-label>
                                    <input matInput type="number" [formControl]="incomeConsecutiveControl" />
                                </mat-form-field>
                                <button mat-raised-button color="primary"
                                    class="bg-color-primary field-action-btn save-btn" type="button"
                                    (click)="updateConsecutive('Journal')" matTooltip="Guardar">
                                    <i class="fas fa-save"></i>
                                </button>
                            </div>
                            <div class="field-with-action">
                                <mat-form-field appearance="outline">
                                    <mat-label>Consecutivo de comprobantes de egresos</mat-label>
                                    <input matInput type="number" [formControl]="expenseConsecutiveControl" />
                                </mat-form-field>
                                <button mat-raised-button color="primary"
                                    class="bg-color-primary field-action-btn save-btn" type="button"
                                    (click)="updateConsecutive('Receipt')" matTooltip="Guardar">
                                    <i class="fas fa-save"></i>
                                </button>
                            </div>
                            <div class="field-with-action" *ngIf="isTeclogiUser">
                                <mat-form-field appearance="outline">
                                    <mat-label>Consecutivo de recibos de LoggiCash</mat-label>
                                    <input matInput type="number" [formControl]="receiptFintechConsecutiveControl" />
                                </mat-form-field>
                                <button mat-raised-button color="primary"
                                    class="bg-color-primary field-action-btn save-btn" type="button"
                                    (click)="updateConsecutive('ReceiptFintech')" matTooltip="Guardar">
                                    <i class="fas fa-save"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Utilidades de servicios adicionales -->
                    <div class="config-card config-block"
                        *ngIf="tabsAndSectionsToShow['BillingAndPayments']['additionalServicesUtilities']">
                        <div class="config-block__head">
                            <span class="config-title">Utilidades de servicios adicionales</span>
                            <small>A continuación podrá configurar las utilidades de los servicios adicionales, aquellas
                                que
                                tengan más de una entidad a cobrar pueden ser configuradas individualmente.
                                Las utilidades en 0% no se validarán al momento de crear el servicio adicional.</small>
                        </div>
                        <app-additional-services-config *ngIf="tabState['BillingAndPayments'].loaded" class="d-block"
                            [nitCompany]="company?.companyId" [additionalCosts]="basicAdditionalServices"
                            [whoToPays]="billingWhoToPays"></app-additional-services-config>
                    </div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Pagos" *ngIf="tabsAndSectionsToShow['Payments']">
            <div class="config-tab-content config-tab-content--cards">
                <div class="config-card" *ngIf="tabsAndSectionsToShow['Payments']['paymentConsolidation']">
                    <div class="config-block__head">
                        <span class="config-title">Configurar modalidad de dispersión de pagos (Archivo PAB)</span>
                    </div>
                    <div class="config-fields-grid">
                    </div>

                    <div id="additionalServicesStep" class="config-group__section">

                        <form class="d-flex flex-column align-items-baseline" [formGroup]="formPaymentConsolidation"
                            (ngSubmit)="onSubmitPaymentConsolidation()">
                            <mat-label>
                                <b>Si habilita esta opción, los pagos realizados al mismo beneficiario se agruparán en
                                    una sola
                                    transacción al generar el archivo PAB.</b>
                            </mat-label>
                            <div class="col-md-4 my-3">
                                <mat-button-toggle-group name="paymentConsolidation" formControlName="active">
                                    <mat-button-toggle [value]="true">
                                        Sí
                                    </mat-button-toggle>
                                    <mat-button-toggle [value]="false">
                                        No
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                            <div class="button-container mt-2 w-100 justify-content-center">
                                <button mat-raised-button color="primary" class="bg-color-primary"
                                    type="submit">Guardar</button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </mat-tab>

        <mat-tab label="Perfil de riesgo" *ngIf="tabsAndSectionsToShow['RiskProfile']">
            <div class="config-tab-content config-tab-content--cards" (mouseenter)="refreshRiskViewports()">
                <form class="config-card config-block risk-profile" [formGroup]="formRiskProfile"
                    (ngSubmit)="onSubmitRiskProfile()">
                    <div class="config-block__head">
                        <span class="config-title">Perfil de riesgo</span>
                        <small>Define los valores que determinan el riesgo de los servicios, y
                            clasifica
                            las empresas por su perfil.</small>
                    </div>

                    <mat-checkbox formControlName="enabled">
                        <p class="text-bold mb-0">Activar perfil de riesgo automático</p>
                        <small>Si se desactiva, el perfil de riesgo se asigna manualmente (desde el detalle del
                            servicio) y no se valida el mínimo de viajes del vehículo ni se exige perfil para
                            iniciar el servicio.</small>
                    </mat-checkbox>

                    <div class="risk-profile__section">
                        <span class="config-subtitle">Valor declarado de la mercancía</span>
                        <div class="risk-profile__thresholds">
                            <div class="risk-profile__field">
                                <mat-form-field appearance="outline" class="config-input">
                                    <mat-label>Valor en COP para riesgo alto<span class="asterisk">*</span></mat-label>
                                    <span matPrefix class="mr-1">$</span>
                                    <input matInput type="text" currencyMask formControlName="threshold"
                                        placeholder="100.000.000">
                                    <mat-error *ngIf="formRiskProfile.get('threshold').errors?.required">
                                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                                    </mat-error>
                                    <mat-error *ngIf="formRiskProfile.get('threshold').errors?.min">
                                        {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'valor', '1') }}
                                    </mat-error>
                                </mat-form-field>
                                <small>Se aplica desde este valor (mayor o igual)</small>
                            </div>
                            <div class="risk-profile__field">
                                <mat-form-field appearance="outline" class="config-input">
                                    <mat-label>Valor en COP para riesgo medio<span
                                            class="optional">(opcional)</span></mat-label>
                                    <span matPrefix class="mr-1">$</span>
                                    <input matInput type="text" currencyMask formControlName="mediumThreshold"
                                        [secureZero]="false" placeholder="50.000.000">
                                    <mat-error *ngIf="formRiskProfile.get('mediumThreshold').errors?.notBelowHigh">
                                        Debe ser menor al valor para riesgo alto
                                    </mat-error>
                                </mat-form-field>
                                <small *ngIf="canConfigureMediumThreshold">Se aplica desde este valor y hasta el riesgo
                                    alto</small>
                                <small *ngIf="!canConfigureMediumThreshold">Configura primero el valor para riesgo
                                    alto</small>
                            </div>
                        </div>
                        <div class="risk-bands">
                            <div class="risk-bands__row" [ngClass]="'risk-bands__row--' + band.bucket"
                                *ngFor="let band of riskValueBands">
                                <span class="risk-bands__label">{{ band.label }}</span>
                                <span class="risk-bands__value">{{ band.description }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="risk-profile__section">
                        <span class="config-subtitle">Viajes mínimos del vehículo por perfil</span>
                        <small>Viajes ya realizados que se le exigen al vehículo para poder asignarlo a un servicio,
                            según el perfil del servicio. Déjalo vacío para no exigir viajes. El riesgo bajo nunca exige
                            viajes.</small>
                        <div class="risk-profile__thresholds">
                            <div class="risk-profile__field">
                                <mat-form-field appearance="outline" class="config-input">
                                    <mat-label>Viajes para riesgo alto<span
                                            class="optional">(opcional)</span></mat-label>
                                    <input matInput type="text" onlyNumbersInt formControlName="tripsRequiredHigh"
                                        placeholder="10">
                                    <mat-error *ngIf="formRiskProfile.get('tripsRequiredHigh').errors?.min">
                                        {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'viajes', '1') }}
                                    </mat-error>
                                </mat-form-field>
                                <small>Se exige a los servicios de riesgo alto</small>
                            </div>
                            <div class="risk-profile__field">
                                <mat-form-field appearance="outline" class="config-input">
                                    <mat-label>Viajes para riesgo medio<span
                                            class="optional">(opcional)</span></mat-label>
                                    <input matInput type="text" onlyNumbersInt formControlName="tripsRequiredMedium"
                                        placeholder="4">
                                    <mat-error *ngIf="formRiskProfile.get('tripsRequiredMedium').errors?.min">
                                        {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'viajes', '1') }}
                                    </mat-error>
                                </mat-form-field>
                                <small *ngIf="canConfigureTripsRequiredMedium">Se exige a los servicios de riesgo
                                    medio</small>
                                <small *ngIf="!canConfigureTripsRequiredMedium">Sin valor para riesgo medio ningún
                                    servicio queda en ese perfil</small>
                            </div>
                        </div>
                    </div>

                    <div class="risk-profile__section">
                        <span class="config-subtitle">Empresas por perfil de riesgo</span>
                        <small>Selecciona empresas y muévelas al perfil de destino. Los cambios se aplican al
                            guardar.</small>

                        <div class="risk-move" *ngIf="selectedRiskCount">
                            <span class="risk-move__label">{{ selectedRiskCount }} seleccionada(s). Mover a:</span>
                            <div class="risk-move__targets">
                                <button type="button" mat-stroked-button class="risk-move__btn"
                                    *ngFor="let bucket of riskBuckets" [disabled]="!riskMovableCount(bucket)"
                                    (click)="moveSelectedRiskCompaniesTo(bucket)">
                                    <span class="risk-dot" [ngClass]="'risk-dot--' + bucket"></span>
                                    {{ riskBucketLabels[bucket] }}
                                </button>
                            </div>
                        </div>

                        <div class="risk-panels">
                            <div class="risk-panel" [ngClass]="'risk-panel--' + bucket"
                                *ngFor="let bucket of riskBuckets">
                                <div class="risk-panel__header">
                                    <span class="risk-dot" [ngClass]="'risk-dot--' + bucket"></span>
                                    <span class="text-bold">{{ riskBucketLabels[bucket] }}</span>
                                    <span class="risk-panel__count">{{ riskCompanies[bucket].length }}</span>
                                    <button type="button" class="risk-link ml-auto"
                                        (click)="toggleSelectAllRisk(bucket)"
                                        [disabled]="!filteredRiskCompanies[bucket].length">
                                        {{ allFilteredRiskSelected(bucket) ? 'Quitar selección' : 'Seleccionar todas' }}
                                    </button>
                                </div>
                                <div class="risk-panel__search">
                                    <mat-form-field appearance="outline" class="w-100 risk-search">
                                        <mat-label>Buscar empresa</mat-label>
                                        <input matInput type="text" placeholder="Nombre o NIT"
                                            [(ngModel)]="riskSearch[bucket]" [ngModelOptions]="{ standalone: true }"
                                            (ngModelChange)="onRiskSearchChange()">
                                        <i matSuffix class="fas cursor-pointer"
                                            [ngClass]="riskSearch[bucket] ? 'fa-times-circle' : 'fa-search'"
                                            (click)="clearRiskSearch(bucket)"></i>
                                    </mat-form-field>
                                </div>
                                <div class="risk-empty" *ngIf="loadingRiskCompanies">
                                    <span>Cargando empresas...</span>
                                </div>
                                <cdk-virtual-scroll-viewport itemSize="44" class="risk-list"
                                    *ngIf="!loadingRiskCompanies && filteredRiskCompanies[bucket].length">
                                    <div class="risk-row"
                                        *cdkVirtualFor="let riskCompany of filteredRiskCompanies[bucket]"
                                        [class.risk-row--selected]="isRiskSelected(bucket, riskCompany)"
                                        [class.risk-row--pending]="isRiskPending(riskCompany)"
                                        (click)="toggleRiskCompany(bucket, riskCompany)">
                                        <mat-checkbox [checked]="isRiskSelected(bucket, riskCompany)"
                                            (click)="$event.stopPropagation()"
                                            (change)="toggleRiskCompany(bucket, riskCompany)"></mat-checkbox>
                                        <span class="risk-row__name">{{ riskCompany.name }}</span>
                                        <span class="risk-row__nit">{{ riskCompany.companyId }}</span>
                                    </div>
                                </cdk-virtual-scroll-viewport>
                                <div class="risk-empty"
                                    *ngIf="!loadingRiskCompanies && !filteredRiskCompanies[bucket].length">
                                    <i class="fas risk-empty__icon"
                                        [ngClass]="riskSearch[bucket] ? 'fa-search' : 'fa-building'"></i>
                                    <span>
                                        {{ riskSearch[bucket] ? 'Ninguna empresa coincide con la búsqueda' : 'No hay
                                        empresas en este perfil' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="config-block__actions risk-actions">
                        <div class="risk-pending" *ngIf="hasRiskProfileEdits">
                            <span class="risk-pending__label">Cambios sin guardar:</span>
                            <span class="risk-chip" *ngIf="formRiskProfile.dirty">Valores y viajes mínimos</span>
                            <ng-container *ngFor="let bucket of riskBuckets">
                                <span class="risk-chip" *ngIf="pendingRiskIds[bucket].size">
                                    {{ pendingRiskIds[bucket].size }} empresa(s) a {{
                                    riskBucketLabels[bucket].toLowerCase() }}
                                </span>
                            </ng-container>
                        </div>
                        <div class="risk-actions__buttons">
                            <button type="button" class="risk-link" *ngIf="hasRiskProfileEdits"
                                (click)="discardRiskProfileChanges()">Descartar cambios</button>
                            <button mat-raised-button color="primary" class="bg-color-primary risk-profile__save"
                                type="submit" [disabled]="!hasRiskProfileChanges">Guardar</button>
                        </div>
                    </div>
                </form>
            </div>
        </mat-tab>
        <mat-tab [label]="transportCompaniesTabLabel" *ngIf="tabsAndSectionsToShow['TransportCompanies']">
            <div class="config-tab-content--cards tc-tab">
                <div class="config-tab-toolbar">
                    <!-- Fuera del bloque [hidden]: la empresa elegida define las secciones de abajo. -->
                    <div class="config-tab-toolbar__context">
                        <span class="config-tab-toolbar__context-label">Empresa de transporte:</span>
                        <app-transport-company-context [initialNit]="initialTransportCompanyId"
                            (companyChange)="onTransportCompanyChange($event)">
                        </app-transport-company-context>
                    </div>
                    <button mat-icon-button type="button" class="config-refresh-btn"
                        (click)="refreshTab('TransportCompanies')" [disabled]="tabState['TransportCompanies'].loading"
                        matTooltip="Refrescar">
                        <i class="fas fa-sync-alt" [class.fa-spin]="tabState['TransportCompanies'].loading"></i>
                    </button>
                </div>

                <div *ngIf="tabState['TransportCompanies'].loading" class="config-skeleton">
                    <ngx-skeleton-loader count="5" appearance="line"
                        [theme]="{ height: '48px', 'margin-bottom': '14px' }"></ngx-skeleton-loader>
                </div>

                <div [hidden]="tabState['TransportCompanies'].loading">

                    <!-- Error -->
                    <div *ngIf="!tabState['TransportCompanies'].loading && tabState['TransportCompanies'].error"
                        class="config-card tc-state tc-state--error">
                        <span>No se pudo cargar la información. Intenta nuevamente.</span>
                        <button mat-stroked-button color="primary"
                            (click)="refreshTab('TransportCompanies')">Reintentar</button>
                    </div>

                    <!-- Vacío -->
                    <div *ngIf="!tabState['TransportCompanies'].loading && !tabState['TransportCompanies'].error && tabState['TransportCompanies'].loaded && transportCompanies.length === 0"
                        class="config-card tc-state">
                        <span>No hay empresas de transporte registradas.</span>
                    </div>

                    <!-- Secciones de la empresa elegida en la pastilla: se abre una a la vez -->
                    <mat-accordion
                        *ngIf="!tabState['TransportCompanies'].loading && !tabState['TransportCompanies'].error && selectedTransportCompany as tc"
                        multi="false">
                        <mat-expansion-panel class="tc-panel">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="tc-panel__title">Credenciales RNDC, correo y
                                    póliza</mat-panel-title>
                                <mat-panel-description class="tc-panel__desc">
                                    <span class="tc-chip tc-chip--nit">NIT {{ tc.companyId }}</span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <!-- Credenciales RNDC -->
                            <div class="config-block tc-block" *ngIf="tc.rndcCredentials">
                                <div class="config-block__head">
                                    <span class="config-title">Credenciales RNDC</span>
                                    <span class="tc-chip"
                                        [ngClass]="tc.rndcCredentials.state ? 'tc-chip--on' : 'tc-chip--off'">
                                        {{ tc.rndcCredentials.state ? 'Activo' : 'Inactivo' }}
                                    </span>
                                </div>
                                <app-copyable-secret label="Usuario"
                                    [value]="tc.rndcCredentials.userName"></app-copyable-secret>
                                <app-copyable-secret label="Contraseña" [value]="tc.rndcCredentials.password"
                                    [secret]="true"></app-copyable-secret>
                            </div>

                            <!-- Credenciales de facturación RNDC -->
                            <div class="config-block tc-block" *ngIf="tc.billingRndcCredentials">
                                <div class="config-block__head">
                                    <span class="config-title">Facturación RNDC</span>
                                </div>
                                <app-copyable-secret label="Usuario"
                                    [value]="tc.billingRndcCredentials.userName"></app-copyable-secret>
                                <app-copyable-secret label="Contraseña" [value]="tc.billingRndcCredentials.password"
                                    [secret]="true"></app-copyable-secret>
                            </div>

                            <!-- Monitor RNDC -->
                            <div class="config-block tc-block" *ngIf="tc.monitorRndcCredentials">
                                <div class="config-block__head">
                                    <span class="config-title">Monitor RNDC</span>
                                    <span class="tc-chip"
                                        [ngClass]="tc.monitorRndcCredentials.state ? 'tc-chip--on' : 'tc-chip--off'">
                                        {{ tc.monitorRndcCredentials.state ? 'Activo' : 'Inactivo' }}
                                    </span>
                                </div>
                                <app-copyable-secret label="Usuario"
                                    [value]="tc.monitorRndcCredentials.userName"></app-copyable-secret>
                                <app-copyable-secret label="Contraseña" [value]="tc.monitorRndcCredentials.password"
                                    [secret]="true"></app-copyable-secret>
                            </div>

                            <!-- Correo -->
                            <div class="config-block tc-block" *ngIf="tc.emailCredentials">
                                <div class="config-block__head">
                                    <span class="config-title">Correo</span>
                                </div>
                                <app-copyable-secret label="Usuario"
                                    [value]="tc.emailCredentials.userName"></app-copyable-secret>
                                <app-copyable-secret label="Contraseña" [value]="tc.emailCredentials.password"
                                    [secret]="true"></app-copyable-secret>
                                <div class="tc-field"><span class="tc-field__label">Proveedor</span><span
                                        class="tc-field__value">{{ tc.emailCredentials.emailProvider || '—' }}</span>
                                </div>
                            </div>

                            <!-- Póliza -->
                            <div class="config-block tc-block">
                                <div class="config-block__head">
                                    <span class="config-title">Póliza</span>
                                    <button mat-icon-button type="button" class="tc-edit-button"
                                        *ngIf="hasPermissionToEditTransportCompanyPolicy"
                                        (click)="openTransportCompanyPolicyDialog(tc)" matTooltip="Editar póliza">
                                        <i class="fas fa-pencil-alt"></i>
                                    </button>
                                </div>
                                <div class="tc-policy-empty" *ngIf="!tc.insuranceInformation">No hay información de
                                    póliza registrada.</div>
                                <div class="tc-field"><span class="tc-field__label">NIT entidad emisora</span><span
                                        class="tc-field__value">{{ tc.insuranceInformation?.companyId || '—' }}</span>
                                </div>
                                <div class="tc-field"><span class="tc-field__label">Entidad emisora</span><span
                                        class="tc-field__value">{{ tc.insuranceInformation?.companyName || '—' }}</span>
                                </div>
                                <div class="tc-field"><span class="tc-field__label">N° de póliza</span><span
                                        class="tc-field__value">{{ tc.insuranceInformation?.policyNumber || '—'
                                        }}</span></div>
                                <div class="tc-field"><span class="tc-field__label">Fecha de expiración</span><span
                                        class="tc-field__value">{{ tc.insuranceInformation?.expirationDate || '—'
                                        }}</span></div>
                            </div>

                            <!-- Prefijos RNDC -->
                            <div class="config-block tc-block" *ngIf="tc.rndcPrefix && tc.rndcPrefix.length">
                                <div class="config-block__head">
                                    <span class="config-title">Prefijos RNDC</span>
                                </div>
                                <div class="tc-prefixes">
                                    <span class="tc-chip tc-chip--prefix" *ngFor="let prefix of tc.rndcPrefix">
                                        {{ rndcPrefixTypeDict[prefix.type] || prefix.type }}: <b>{{ prefix.name || '—'
                                            }}</b>
                                    </span>
                                </div>
                            </div>
                        </mat-expansion-panel>

                        <mat-expansion-panel class="tc-panel"
                            *ngIf="tabsAndSectionsToShow['TransportCompanies']['billingSiigo']"
                            (opened)="onBillingSectionOpened()" (closed)="billingSectionExpanded = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="tc-panel__title">Facturación</mat-panel-title>
                                <mat-panel-description class="tc-panel__desc">
                                    Tipo de documento de factura y productos Siigo
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div *ngIf="billingSectionLoading" class="config-skeleton">
                                <ngx-skeleton-loader count="3" appearance="line"
                                    [theme]="{ height: '48px', 'margin-bottom': '14px' }"></ngx-skeleton-loader>
                            </div>
                            <div class="tc-billing" [hidden]="billingSectionLoading">
                                <ng-container *ngTemplateOutlet="siigoBillingSections"></ng-container>
                            </div>
                        </mat-expansion-panel>

                        <mat-expansion-panel class="tc-panel"
                            *ngIf="tabsAndSectionsToShow['TransportCompanies']['billingSiigo']"
                            (opened)="onAccountingSectionOpened()" (closed)="accountingSectionExpanded = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="tc-panel__title">Contabilidad</mat-panel-title>
                                <mat-panel-description class="tc-panel__desc">
                                    Tipo de documento contable
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div *ngIf="accountingSectionLoading" class="config-skeleton">
                                <ngx-skeleton-loader count="1" appearance="line"
                                    [theme]="{ height: '48px', 'margin-bottom': '14px' }"></ngx-skeleton-loader>
                            </div>
                            <div class="tc-billing" [hidden]="accountingSectionLoading">
                                <div class="config-card">
                                    <p class="config-title mb-2">Tipo de documento contable</p>
                                    <mat-form-field appearance="outline" class="config-input config-input--wide">
                                        <mat-select (selectionChange)="onSelectAccountingDocumentType($event)"
                                            [value]="accountingDocumentType"
                                            [disabled]="!listAccountingDocumentTypes.length">
                                            <mat-option *ngFor="let documentType of listAccountingDocumentTypes"
                                                [value]="documentType">
                                                {{documentType.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div *ngIf="messageListAccountingDocumentTypes" class="alert alert-danger my-2"
                                        role="alert">
                                        {{messageListAccountingDocumentTypes}}
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

    <!-- Facturación Siigo: en "Empresas de transporte" (por empresa) o en "Facturación y Contabilidad" (SaaS sin transporte). -->
    <ng-template #siigoBillingSections>
        <!-- Tipo de documento de factura -->
        <div class="config-card">
            <p class="config-title mb-2">Tipo de documento de factura<span class="asterisk">*</span>
            </p>
            <mat-form-field appearance="outline" class="config-input config-input--wide">
                <mat-select (selectionChange)="onSelectTypeBill($event)" [value]="typeBill"
                    [compareWith]="compareTypeBill">
                    <mat-option *ngFor="let typeBill of listTypeBill" [value]="typeBill">
                        {{typeBill.description}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div *ngIf="messageListTypeBill" class="alert alert-danger my-2" role="alert">
                {{messageListTypeBill}}
            </div>
        </div>

        <!-- Productos Siigo - Ciudades -->
        <div id="productsStep" class="config-card">
            <div class="config-block__head">
                <span class="config-title">Productos Siigo - Ciudades
                </span>
                <small>Configura el código retefuente y producto Siigo para ciudades.</small>
            </div>
            <app-autocomplete-city class="config-input--wide d-block" [inputFormControl]="cityControl"
                [options]="optionsCity">
            </app-autocomplete-city>
        </div>

        <!-- Servicios adicionales: productos Siigo e impuestos de facturación en una sola sección. -->
        <div class="config-card additional-services">
            <div class="config-block__head">
                <span class="config-title">Servicios adicionales</span>
                <small>Producto Siigo vinculado e impuestos que se aplican al facturar cada servicio adicional.</small>
            </div>
            <div id="additionalServicesStep" class="additional-services__section">
                <span class="config-subtitle">Productos Siigo</span>
                <small>Cada servicio adicional debe estar vinculado a un producto Siigo.</small>
                <div class="config-products">
                    <div *ngIf="listAdditionalServices.length; else emptyAdditionalServices" class="config-fields-grid">
                        <mat-form-field appearance="outline"
                            *ngFor="let additionalService of listAdditionalServices; let i = index">
                            <mat-label>{{additionalService.name}}</mat-label>
                            <mat-select (selectionChange)="onProductSiigoChange($event, i)"
                                [value]="additionalService?.productSiigoId" [compareWith]="compareProductSiigo"
                                [disabled]="isLoadingProducts || savingAdditionalServiceProduct">
                                <mat-option *ngFor="let option of listProductSiigo" [value]="option.code">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                            <i matSuffix *ngIf="isLoadingProducts"
                                class="fas fa-spinner fa-spin products-loading-spinner"></i>
                        </mat-form-field>
                    </div>
                    <ng-template #emptyAdditionalServices>
                        <div class="text-strong my-2">
                            {{messageListAdditionalServices}} configurados para la empresa
                        </div>
                    </ng-template>
                    <div *ngIf="messageListProductSiigo" class="alert alert-danger my-2" role="alert">
                        {{messageListProductSiigo}}
                    </div>
                </div>
            </div>

            <!-- Impuestos de facturación: solo lectura, independiente del producto Siigo. -->
            <div class="additional-services__section" *ngIf="listAdditionalServices.length">
                <span class="config-subtitle">Impuestos de facturación</span>
                <small>Impuestos que se aplican al facturar cada servicio adicional.</small>
                <div class="billing-taxes">
                    <div class="billing-taxes__row" *ngFor="let additionalService of listAdditionalServices">
                        <span class="billing-taxes__service">{{ additionalService.name }}</span>
                        <div class="billing-taxes__list">
                            <span class="billing-taxes__chip" *ngFor="let tax of additionalService.billingTaxes">
                                {{ tax.name }}
                            </span>
                            <span class="billing-taxes__empty" *ngIf="!additionalService.billingTaxes?.length">
                                Sin impuestos configurados
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>